import { render, staticRenderFns } from "./trainingEventUpdate.vue?vue&type=template&id=98fa2c7a&"
import script from "./trainingEventUpdate.vue?vue&type=script&lang=js&"
export * from "./trainingEventUpdate.vue?vue&type=script&lang=js&"
import style0 from "./trainingEventUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports